import React, { useContext, useState } from 'react';
import { Parallax } from "react-parallax";
import { Link } from "react-router-dom";
import { AppContext } from '../main';



// const banners = {
//     BG_IMAGE: "./img/background/2.webp",
//     IMAGE: "./img/misc/man-with-phone.webp",
//     SUBTITLE: "PLAY ALL YOU WANT",
//     HEADING: "Sign up for occasional newsletters and promotions",
//     DESCRIPTION:
//         "Enim sit laborum enim ut in excepteur aliqua consequat est ut aliquip nostrud sunt deserunt consequat fugiat adipisicing minim aliquip do adipisicing cupidatat esse ut irure incididunt ullamco dolor laboris anim ea do ut anim.",
// };

const Download = (props) => {
    const {
        handleEditItem
    } = props

    const { appState
    } = useContext(AppContext);
    const {
        banners = {
            BG_IMAGE: "./img/background/2.webp",
            IMAGE: "./img/misc/man-with-phone.webp",
            SUBTITLE: "PLAY ALL YOU WANT",
            HEADING: "Sign up for occasional newsletters and promotions",
            DESCRIPTION:
                "Enim sit laborum enim ut in excepteur aliqua consequat est ut aliquip nostrud sunt deserunt consequat fugiat adipisicing minim aliquip do adipisicing cupidatat esse ut irure incididunt ullamco dolor laboris anim ea do ut anim.",
        }
        , editMode = false
    } = appState



    return (
        <div className="container">
            <div className="row position-relative">
                <div className="col-lg-12">
                    <Parallax className="padding60 sm-padding40" bgImage={banners.BG_IMAGE} strength={400}>
                        <div className="col-lg-6">
                            <div className="subtitle wow fadeInUp mb-3">{banners.SUBTITLE}</div>
                            <h2 className="wow fadeInUp" data-wow-delay=".2s">{banners.HEADING}</h2>
                            <p>{banners.DESCRIPTION}</p>
                        </div>
                    </Parallax>
                    <img
                        width="700"
                        height="550"
                        src={banners.IMAGE}
                        className="max-content sm-hide position-absolute bottom-0 end-0"
                        alt="Man with Phone"
                    />
                </div>
            </div>
        </div>
    );
};

export default Download;
